import { darken, fade } from "@material-ui/core/styles/colorManipulator";
import React from "react";
import { withTranslation, WithTranslation } from "react-i18next";
import styled from "styled-components";
import WithDefaults from "Shared/WithDefaults";
import { Condition, TradeIn } from "Types/TradeIn";
import { CircleCheck } from "../../../shared/Icons";

export const Root = styled("div")<{ selected?: boolean }>`
    background: ${(props) => props.theme.palette.common.white};
    border: 2px solid ${(props) => props.theme.palette.grey[10]};
    margin: 6px 0 0;
    position: relative;

    :hover {
        background: ${(props) => darken(props.theme.palette.common.white, 0.08)};
        transition: all 0.3s ease;
    }

    :active {
        background: ${(props) => darken(props.theme.palette.common.white, 0.25)};
    }

    :disabled {
        background: ${(props) => props.theme.palette.grey[20]};
        cursor: default;
    }

    ${(props) => props.theme.breakpoints.up("desktop")} {
        flex: 0 0 182px;
        margin: 10px;
    }

    /* stylelint-disable */
    ${(props) =>
        props.selected &&
        `
        background: ${fade(props.theme.palette.secondary.main, 0.08)};
        border: 2px solid ${props.theme.palette.secondary.main};
        box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.25);
    `}/* stylelint-enable */;
`;

const StyledIcon = styled(CircleCheck)<{ selected?: boolean }>`
    display: none;

    /* stylelint-disable */
    ${(props) =>
        props.selected &&
        `
        ${props.theme.breakpoints.up("desktop")} {
            background-color: #f9f9f9;
            border-radius: 15px;
            color: ${props.theme.palette.secondary.main};
            display: block;
            font-size: 20px;
            position: absolute;
            right: -11px;
            top: -10px;
        }
    `}/* stylelint-enable */;
`;

interface ConditionOptionProps {
    description: string;
    label: Condition;
    selected?: boolean;
    setSelected: (object: Partial<TradeIn>) => void;
    tradePending: Partial<TradeIn>;
    valueRange: string;
}

const defaultProps = {
    selected: false,
};

class ConditionOption extends React.Component<ConditionOptionProps & WithTranslation> {
    public render() {
        return (
            <Root
                className={"ConditionOption__Container"}
                onClick={this.handleSetSelect}
                selected={this.props.selected}
                data-e2e="conditionOptionRoot"
            >
                <StyledIcon selected={this.props.selected} />
                <div className="ConditionOption__body">
                    <span className="ConditionOption__label">{this.getTradePendingLabel()}</span>
                    <span className="ConditionOption__valueRange">{this.props.valueRange}</span>
                    <div className="ConditionOption__descrition--container">
                        <span className="ConditionOption__description">{this.props.description}</span>
                    </div>
                </div>
            </Root>
        );
    }

    protected handleSetSelect = (event: any) => {
        this.props.setSelected({
            customer_estimate: this.tradePendingValue(this.props.tradePending),
            condition: this.props.label,
        });
    };

    protected tradePendingValue = (tradePending: Partial<TradeIn>) => {
        switch (this.props.label) {
            case Condition.Low:
                return tradePending.tp_tradein_low;
            case Condition.Target:
                return tradePending.tp_tradein_target;
            case Condition.High:
                return tradePending.tp_tradein_high;
            default:
                return tradePending.tp_tradein_target;
        }
    };

    protected getTradePendingLabel = () => {
        const { t } = this.props;

        switch (this.props.label) {
            case Condition.Low:
                return t("TradePending.Condition.fair");
            case Condition.Target:
                return t("TradePending.Condition.good");
            case Condition.High:
                return t("TradePending.Condition.great");
            default:
                return t("TradePending.Condition.good");
        }
    };
}

export default withTranslation()(WithDefaults(defaultProps, ConditionOption));
